import OrderApprove from '@/pages/approveManage/orderApprove'

export default [
  {
    path: '/orderApprove',
    name: 'OrderApprove',
    component: OrderApprove,
    meta: { name: '订单审批' }
  }
]



// WEBPACK FOOTER //
// ./src/router/approveManage/orderApprove.js